/**
 * 开始内容检查请求参数
 */
export interface StartCheckContentRequest {
    /**
     * 任务ID
     */
    task_id: string;
    /**
     * 章节类型
     */
    chapter_type: string;
    /**
     * 是否重新开始
     */
    regenerate?: boolean;
}

export const StartCheckContentApi = Symbol.for('StartCheckContentApi');

/**
 * 开始内容检查API接口
 */
export interface StartCheckContentApi {
    /**
     * 开始内容检查
     * @param data 请求参数
     * @param abortSignal 取消信号
     * @returns 响应结果
     */
    startCheckContent(data: StartCheckContentRequest, abortSignal?: AbortSignal): Promise<void>;
}
